<template>
  <div class="booking-page-body-content">
    <!--<template v-if="loading">-->
      <!--<v-progress-circular :size="250" :width="4" indeterminate color="success">-->
        <!--<span>loading</span>-->
      <!--</v-progress-circular>-->
    <!--</template>-->
    <!--<template v-else>-->
      <template v-if="backendError">
        <p class="headline text-xs-center red--text">
          <v-icon color="red" size="50px">error_outline</v-icon><br/>
          Server Error: {{ backendError.message }}
        </p>
      </template>
      <template v-else>

        <v-container grid-list-sm class="px-0 py-0">
          <!--<v-layout row wrap text-xs-center></v-layout>-->
          <!-- selected seat details for POS channel -->
          <v-layout v-if="!loading && channel !== 'ch_kiosk'" row>
            <v-flex>
              <v-card>
                <v-card-text class="py-1">
                  <v-layout row>
                    <v-flex xs2 class="mx-0 my-0 pt-2 px-0">
                      <v-switch :label="bookingInfoString"
                                value input-value="true"
                                v-model="bookingEditMode"
                                color="teal accent-2"
                      ></v-switch>
                    </v-flex>
                    <!--<v-flex xs2 class="mx-0 my-0 pt-2 px-0">-->
                      <!--<v-switch label="Score View"-->
                                <!--value input-value="true"-->
                                <!--v-model="scoreView"-->
                                <!--color="blue-grey darken-4"-->
                      <!--&gt;</v-switch>-->
                    <!--</v-flex>-->
                    <v-flex xs10 class="mx-0 my-0 py-3 px-0">
                      <span class="body-2">
                        <v-chip color="red darken-3" text-color="white">
                          <span id="bookie-available-seats">{{ availableSeat }}</span>&nbsp;Out of&nbsp;
                          <span id="bookie-capacity">{{ totalCapacity }}</span>&nbsp;Seats Available
                        </v-chip>
                        <v-chip color="blue darken-2" text-color="white">
                          {{ selectedSeatsNames.length }}&nbsp;Out of&nbsp;{{ numSeats }}&nbsp;Seats Selected.
                        </v-chip>
                        <v-chip color="green darken-1" text-color="white">
                          <span class="body-2"
                                id="bookie-selected-seats"
                                :data-seat_ids="selectedSeatsIds"
                                :data-Seat_names="selectedSeatsNames"
                          >
                            Selected seats: {{ selectedSeatsNames }}
                          </span>
                        </v-chip>
                      </span>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>

          <!-- selected seat details for kiosk -->
          <div v-if="channel === 'ch_kiosk'"
               hidden
               id="bookie-selected-seats"
               :data-seat_ids="selectedSeatsIds"
               :data-Seat_names="selectedSeatsNames"></div>

          <!-- Canvas -->
          <v-card v-if="!loading">
            <v-card-text
                    ref="bookingCanvasContainer"
                    style="overflow-x: scroll;"
                    class="py-0 px-0"
            >
              <div :class="{'c-canvas' : channel !== 'ch_kiosk' , 'c-canvas-kiosk' : channel === 'ch_kiosk'}"
                   :style="{ 'width': canvasWidth + 'px', 'height': canvasHeight + 'px', 'zoom': canvasZoom + '%' }"
              >
                <c-seat v-for="(slot, index) in slotsUnbound"
                        style="position: absolute;"
                        :key="'st'+index"
                        :my-seat="slot"
                        :booking-mode="true"
                        @seat-selected="selectSeat($event, index)"
                        :reserved="slot.reserved"
                        :booked="slot.booked"
                        @bulk-move-destination="setBulkMoveDestination($event, index)"
                        @enable-edit-mode="enableEditMode($event, index)"
                        :reposition-booking="slot.reposition"
                        :reposition-hint="slot.repositionHint"
                ></c-seat>
                <!--:score-view="scoreView"-->
                <!-- @bulk-move-origin="setBulkMoveOrigin" -->

                <template v-for="(uiComponent, index) in uiComponentsUnbound">
                  <c-screen v-if="uiComponent.type === 'SCREEN'"
                            :key="'sc'+index"
                            :my-screen="uiComponent"
                            :booking-mode="true"
                  ></c-screen>
                  <c-wall v-else-if="uiComponent.type === 'WALL'"
                          :key="'wl'+index"
                          :my-wall="uiComponent"
                          :booking-mode="true"
                  ></c-wall>
                  <c-railing v-else-if="uiComponent.type === 'RAILING'"
                             :key="'rl'+index"
                             :my-railing="uiComponent"
                             :booking-mode="true"
                  ></c-railing>
                  <c-ui-text v-else-if="uiComponent.type === 'TEXT'"
                             style="position: absolute;"
                             :key="'txt'+index"
                             :my-text="uiComponent"
                             :booking-mode="true"
                  ></c-ui-text>
                </template>
              </div>
            </v-card-text>
          </v-card>
          <!-- End Canvas -->
        </v-container>

        <!-- Legend -->
        <c-legend v-if="!loading && channel !== 'ch_kiosk'"></c-legend>
        <!-- End legend -->
      </template>
    <!--</template>-->
  </div>
</template>

<script>
  import {mapState} from 'vuex';
  import {mapActions} from 'vuex';

  export default {
    name: "Booking",

    props: {
      eventId: String,
      numSeats: String,
      strSeatIds: String,
      deviceId: String,
      channel: String,
      strRules: String,
      happySeatBenchMark: String
    },

    data: () => ({
      loading: true,
      myEvent: null,
      selectedLayout: null,
      backendError: null,
      myBookings: [],

      canvasHeight: 0,
      canvasWidth: 0,
      minX: 0,
      maxX: 0,
      minY: 0,
      maxY: 0,
      slots: [],
      slotsUnbound: [],
      uiComponents: [],
      uiComponentsUnbound: [],
      totalCapacity: 0,
      bulkMoveOrigin: null,
      bulkMoveDestination: null,
      selectedSlotIndexes: [],
      bookingEditMode: false,
      // scoreView: false,
      defaultSeatWidth: 36,
      businessRules: [],
      activeBusinessRules: [],
      previouslyAvailableSeats: 0,
      foundPreselectedSeats: false,
      availableSeat: 0,
      selectedSeats: []
    }),

    computed: {
      // selectedSeats() {
      //   let selectedSeats = [];
      //   let i = 0;
      //   for (i; i < this.slots.length; i++) {
      //     let seat = this.slots[i];
      //     if (seat.reserved) {
      //       selectedSeats.push(seat);
      //     }
      //   }
      //   return selectedSeats;
      // },
      repositionSeatCount() {
        let repositionSeatCount = [];
        let i = 0;
        for (i; i < this.slotsUnbound.length; i++) {
          let seat = this.slotsUnbound[i];
          if (seat.reposition) {
            repositionSeatCount.push(seat);
          }
        }
        return repositionSeatCount;
      },
      selectedSeatsNames() {
        // console.log('selected ' + this.selectedSeats.length);
        let seatNames = [];
        let i = 0;
        for (i; i < this.selectedSeats.length; i++) {
          let seatName = this.selectedSeats[i].rowLabel + '-' + this.selectedSeats[i].slotNumber;
          seatNames.push(seatName);
        }
        return seatNames;
      },
      selectedSeatsIds() {
        // console.log('selected ' + this.selectedSeats.length);
        let seatIds = [];
        let seatsCount = 0;
        let i = 0;
        for (i; i < this.selectedSeats.length; i++) {
          seatIds.push(this.selectedSeats[i].id);
          seatsCount += this.selectedSeats[i].capacity;
        }
        // let responseArray = {"eventId": "bookieSeats", "seatIds": seatIds, "seatNames": this.selectedSeatsNames, "seatsCount": seatsCount, "capacity": this.totalCapacity, "availableSeatsCount": this.availableSeat };
        // window.parent.postMessage(responseArray, "*");
        // console.log('From Bookie: ', responseArray);
        return seatIds;
      },
      // preselectedSeatIDs() {
      //   let seatIDs = [];
      //   let strSeatIDs = this.strSeatIds;
      //   if (strSeatIDs && strSeatIDs !== '') {
      //     seatIDs = Array.map(strSeatIDs.split(','), Number);
      //   }
      //
      //   return seatIDs;
      // },
      // availableSeat() {
      //   let aSeats = 0;
      //   this.totalCapacity = 0;
      //   for (let i = 0; i < this.slots.length; i++) {
      //     let mySeat = this.slots[i];
      //     this.totalCapacity += mySeat.capacity;
      //     if (!(mySeat.reserved || mySeat.booked || mySeat.status === 'BROKEN')) {
      //       aSeats += mySeat.capacity;
      //     }
      //   }
      //   return aSeats;
      // },
      bookingInfoString() {
        // return 'Reposition Mode | ' + this.availableSeat + ' Out of ' + this.totalCapacity + ' Available Seats. | Selected Seats: ' + this.selectedSeatsNames;
        return 'Edit Mode';
      },
      // bRuleIDs() {
      //   let numIDs = [];
      //   if (this.strRules) {
      //     let idArray = (this.strRules) ? this.strRules.split(',') : [];
      //     for (let i = 0; i < idArray.length; i++) {
      //       try {
      //         idArray[i] = parseInt(idArray[i]);
      //         if (idArray[i])
      //           numIDs.push(idArray[i]);
      //       } catch (e) {
      //         // console.log(e);
      //       }
      //     }
      //   }
      //   return numIDs;
      // },
      // intNumSeats() {
      //   return (this.numSeats && parseInt(this.numSeats)) ? parseInt(this.numSeats) : 0;
      // },
      // availabilityPercent() {
      //   return (this.previouslyAvailableSeats / this.totalCapacity) * 100;
      // },
      // bookingPercent() {
      //   return 100 - this.availabilityPercent;
      // }
      ...mapState(['canvasZoom'])
    },

    watch: {
      bookingEditMode(value) {
        if (!value) {
          this.setRepositionToFalse();
          this.setRepositionHintToFalse();
        }
      }
    },

    methods: {
      /* get event by ID */
      getEvent() {
        let eventPayload = {
          eventId: this.eventId ? parseInt(this.eventId) : null,
          numSeats: this.numSeats ? parseInt(this.numSeats) : null,
          recommendationRules: (this.strRules) ? Array.map(this.strRules.split(','), Number) : [],
          deviceId: this.deviceId,
          channelCode: this.channel,
          happySeatBenchMark: this.happySeatBenchMark ? parseFloat(this.happySeatBenchMark) : null
        };
        // console.log("eventPayload: ", eventPayload);
        axios.post(BACKEND_URL+'/api/events/'+this.eventId+'/booking', eventPayload).then(({data})=>{
          // console.log(data);
          this.slotsUnbound = data.slots;
          this.uiComponentsUnbound = data.uiComponents;
          this.canvasHeight = data.canvasHeight;
          this.canvasWidth = data.canvasWidth;
          this.totalCapacity = data.totalCapacity;
          this.availableSeat = data.availableSeat;
          this.selectedSlotIndexes = data.selectedSlotIndexes;
          this.selectedSeats = data.selectedSlots;
          this.activeBusinessRules = data.activeBusinessRules;

          this.loading = false;

          /* fit the layout to the canvas container size */
          this.zoomLayout();
        }).catch((error)=>{
          if (error.message === 'Network Error') {
            // console.log('Cannot connect to server');
            this.backendError = {};
            this.backendError.message = 'Cannot connect to server';
          } else {
            console.log(error);
            this.backendError = error.response.data;
          }
          this.loading = false;
        });
        /*
        axios.get(BACKEND_URL+'/api/events/'+this.eventId).then(({data})=>{
          this.myEvent = data;
          this.myBookings = data.bookings;

          console.log(this.myEvent.layout.slots);

          let mySlots = this.myEvent.layout.slots;
          let myUiComponents = this.myEvent.layout.uiComponents;
          let minMaxSlotsY = this.findMinMaxY(mySlots);
          let minMaxSlotsX = this.findMinMaxX(mySlots);
          let minMaxItemsY = this.findMinMaxY(myUiComponents);
          let minMaxItemsX = this.findMinMaxX(myUiComponents);
          let minY = (minMaxSlotsY[0] - minMaxItemsY[0] > 0) ? minMaxItemsY[0] : minMaxSlotsY[0];
          let maxY = (minMaxSlotsY[1] - minMaxItemsY[1] < 0) ? minMaxItemsY[1] : minMaxSlotsY[1];
          this.canvasHeight = (maxY - minY) + 20;
          let newZeroY = minY - 10;
          let minX = (minMaxSlotsX[0] - minMaxItemsX[0] > 0) ? minMaxItemsX[0] : minMaxSlotsX[0];
          let maxX = (minMaxSlotsX[1] - minMaxItemsX[1] < 0) ? minMaxItemsX[1] : minMaxSlotsX[1];
          this.canvasWidth = (maxX - minX) + 20;
          let newZeroX = minX - 10;

          // Recalculate the new slots coordinates
          // TODO: make this the only loop through slots
          for (let i=0; i < mySlots.length; i++) {
            let slot = mySlots[i];
            slot.x -= newZeroX;
            slot.y -= newZeroY;

            // preselected seats by id
            if (this.preselectedSeatIDs.length > 0) {
              for (let j = 0;  j < this.preselectedSeatIDs.length; j++) {
                if (slot.id === this.preselectedSeatIDs[j]) {
                  slot.reserved = true;
                  this.selectedSlotIndexes.push(i);
                }
              }
            }

            // set booked slots
            for (let j = 0; j < this.myBookings.length; j++) {
              let myBooking = this.myBookings[j];
              if (slot.id === myBooking.slotId) {
                if (myBooking.status === 'RESERVED' && myBooking.deviceId === this.deviceId) {
                  slot.reserved = true;
                  this.selectedSlotIndexes.push(i);
                  this.foundPreselectedSeats = true;
                }
                else
                  slot.booked = true;
                break;
              }
            }

            // slot.booked = true;
            slot.reposition = false;
            slot.repositionHint = false;

            this.slots.push(slot);
          }
          this.slotsUnbound = JSON.parse(JSON.stringify(this.slots));

          // Recalculate the new UI Components coordinates
          for (let i=0; i < myUiComponents.length; i++) {
            let uiComponent = myUiComponents[i];
            uiComponent.x -= newZeroX;
            uiComponent.y -= newZeroY;
            this.uiComponents.push(uiComponent);
          }
          this.uiComponentsUnbound = JSON.parse(JSON.stringify(this.uiComponents));

          // Assign the previously available number of seats.
          this.getPreviouslyAvailableSeatsNumber();

          // get Reservation business rules
          this.getBusinessRules();
        }).catch((error)=>{
          if (error.message === 'Network Error') {
            // console.log('Cannot connect to server');
            this.backendError = {};
            this.backendError.message = 'Cannot connect to server';
          } else {
            console.log(error);
            this.backendError = error.response.data;
          }
          this.loading = false;
        });
        */
      },

      zoomLayout() {
        setTimeout(() => {
          let canvasContainerWidth = this.$refs.bookingCanvasContainer.clientWidth;
          if (this.canvasWidth > canvasContainerWidth) {
            let extraWidth = this.canvasWidth - canvasContainerWidth;
            let extraWidthPercent = extraWidth / this.canvasWidth * 100;
            let zoomVal = this.canvasZoom;
            zoomVal -= extraWidthPercent;
            this.setCanvasZoom(zoomVal);
            // console.log("Container: ", canvasContainerWidth, "Canvas: ", this.canvasWidth, "extraWidth: ", extraWidth, "extraWidthPercent: ", extraWidthPercent);
          }
        });
      },

      /* handle event's layout seat selection */
      selectSeat(e, slotIndex) {
        // let selectedSeat = this.slots[slotIndex];
        let selectedSeat = this.slotsUnbound[slotIndex];

        // Zoom in layout
        let zoomVal = this.canvasZoom;
        if (zoomVal <= this.DEFAULT_CANVAS_ZOOM) {
          zoomVal = this.MAX_CANVAS_ZOOM;
          this.setCanvasZoom(zoomVal);
          setTimeout(() => {
            let zoomPercent = zoomVal / 100;
            let canvasContainerWidth = this.$refs.bookingCanvasContainer.clientWidth;
            this.$refs.bookingCanvasContainer.scrollLeft = (selectedSeat.x * zoomPercent) - (canvasContainerWidth / 2);
          }, 100);
          setTimeout(() => {
            this.$vuetify.goTo(e.clientY, { easing: 'easeInOutCubic' });
          }, 110);
        }

        // check if edit mode is active
        if (this.bookingEditMode) {
          if (selectedSeat.reserved) {
            selectedSeat.reposition = ! selectedSeat.reposition;
            // this.slots.splice(slotIndex, 1, selectedSeat);
            this.slotsUnbound.splice(slotIndex, 1, selectedSeat);
            this.hintEditModeDestination(this.repositionSeatCount.length);
            // console.log("reposition: ", selectedSeat.reposition);
          } else {
            // console.log("move here...");
            this.moveSelectionTo(slotIndex);
          }
        } else {
          // Set seat reservation status
          selectedSeat.reserved = ! selectedSeat.reserved;
          // this.slots.splice(slotIndex, 1, selectedSeat);
          this.slotsUnbound.splice(slotIndex, 1, selectedSeat);
          if (selectedSeat.reserved)
            this.selectedSlotIndexes.push(slotIndex);
          else {
            this.selectedSlotIndexes.forEach((selectedSlotIndex, index, array) => {
              if (selectedSlotIndex === slotIndex)
                array.splice(index, 1);
            });
          }
          this.setSelectedSeats();
        }
      },

      /* get all bookings *
      getAndSetBookedSeats(myBookings) {
        let i = 0;
        Loop1:
        for (i; i < this.slots.length; i++) {
          let j = 0;
          for (j; j < myBookings.length; j++) {
            // console.log('this ' + this.myEvent.layout.slots[i].id + ' and ' + myBookings[j].slotId);
            if (this.slots[i].id === myBookings[j].slotId) {
              // console.log('gets here');
              if (myBookings[j].status === 'RESERVED' && myBookings[j].deviceId === this.deviceId) {
                this.slots[i].reserved = true;
                this.selectedSlotIndexes.push(i);
                this.foundPreselectedSeats = false;
              }
              else
                this.slots[i].booked = true;
              continue Loop1;
            }
          }
        }

        // Assign the previously available number of seats.
        this.getPreviouslyAvailableSeatsNumber();

        // get Reservation business rules
        this.getBusinessRules();
      },
      */

      /* get booked seats */
      // getBookedSeats() {
      //   this.myBookings = this.myEvent.bookings;
      // },

      /* get min and max y */
      // findMinMaxY(arr) {
      //   let min = arr[0].y, max = arr[0].y + ((arr[0].height && (arr[0].height > 0)) ? arr[0].height : 60);
      //
      //   for (let i = 1, len=arr.length; i < len; i++) {
      //     let height = (arr[i].height && (arr[i].height > 0)) ? arr[i].height : 60;
      //     let v = arr[i].y;
      //     min = (v < min) ? v : min;
      //     max = ((v + height) > max) ? (v + height) : max;
      //   }
      //
      //   return [min, max];
      // },

      /* get min and max x */
      // findMinMaxX(arr) {
      //   let min = arr[0].x, max = arr[0].x + ((arr[0].width && (arr[0].width > 0)) ? arr[0].width : 60);
      //
      //   for (let i = 1, len=arr.length; i < len; i++) {
      //     let width = (arr[i].width && (arr[i].width > 0)) ? arr[i].width : 60;
      //     let v = arr[i].x;
      //     min = (v < min) ? v : min;
      //     max = ((v + width) > max) ? (v + width) : max;
      //   }
      //
      //   return [min, max];
      // },

      /* move selected seats to new location */
      moveSelectionTo(slotIndex) {
        let toBeReleasedIndexes = [],
          toBeReservedIndexes = [];
        // count the number of slots to be released.
        this.selectedSlotIndexes.forEach((selectedIndex) => {
          let selectedSlot = this.slotsUnbound[selectedIndex];
          if (selectedSlot.reposition)
            toBeReleasedIndexes.push(selectedIndex);
        });
        if (toBeReleasedIndexes.length > 0) {
          // release the selection
          toBeReleasedIndexes.forEach((toBeReleasedIndex) => {
            let toBeReleasedSlot = this.slotsUnbound[toBeReleasedIndex];
            toBeReleasedSlot.reserved = false;
            toBeReleasedSlot.reposition = false;
            this.slotsUnbound.splice(toBeReleasedIndex, 1, toBeReleasedSlot);
            this.selectedSlotIndexes.splice(this.selectedSlotIndexes.indexOf(toBeReleasedIndex), 1);
          });

          // get the first seat index to be reserved
          toBeReservedIndexes.push(slotIndex);

          // get n left available seat indexes in the destination row
          if (toBeReleasedIndexes.length > 1) {
            let toBeReservedSeats = this.getNextAvailableRightSlots(this.slotsUnbound[slotIndex], toBeReleasedIndexes.length - 1);
            for (let i = 0; i < toBeReservedSeats.length; i++) {
              toBeReservedIndexes.push(this.slotsUnbound.indexOf(toBeReservedSeats[i]));
            }
          }

          // reserve the group of available seats
          toBeReservedIndexes.forEach((toBeReservedIndex) => {
            let toBeReservedSeat = this.slotsUnbound[toBeReservedIndex];
            toBeReservedSeat.reserved = true;
            toBeReservedSeat.reposition = true;
            this.slotsUnbound.splice(toBeReservedIndex, 1, toBeReservedSeat);
            this.selectedSlotIndexes.push(toBeReservedIndex);
          });
        }

        // recall the edit mode move hint function
        this.hintEditModeDestination(this.repositionSeatCount.length);
      },

      /* set the bulk move origin seat */
      // setBulkMoveOrigin(bulkMoveOrigin) {
      //   this.bulkMoveOrigin = bulkMoveOrigin;
      //   console.log("Mouse Down:", this.bulkMoveOrigin.rowLabel, this.bulkMoveOrigin.slotNumber);
      // },

      /* enable edit mode */
      enableEditMode(trigger, slotIndex) {
        // let touchedSlot = this.slots[slotIndex];
        let touchedSlot = this.slotsUnbound[slotIndex];
        let toBeSelectedIndexes = [];
        if (touchedSlot.reserved && !this.bookingEditMode) {
          console.log("It's a long press:", slotIndex);
          this.bookingEditMode = true;
          if (trigger === 'screen-touch')
            toBeSelectedIndexes.push(slotIndex);

          // get all left reserved seat indexes in the origin row
          let toBeSelectedSeats = this.getNextReservedRightSlots(touchedSlot);
          for (let i = 0; i < toBeSelectedSeats.length; i++) {
            // toBeSelectedIndexes.push(this.slots.indexOf(toBeSelectedSeats[i]));
            toBeSelectedIndexes.push(this.slotsUnbound.indexOf(toBeSelectedSeats[i]));
          }

          toBeSelectedIndexes.forEach((toBeSelectedIndex) => {
            // let mySlot = this.slots[toBeSelectedIndex];
            let mySlot = this.slotsUnbound[toBeSelectedIndex];
            mySlot.reposition = true;
            // this.slots.splice(toBeSelectedIndex, 1, mySlot);
            this.slotsUnbound.splice(toBeSelectedIndex, 1, mySlot);
          });

          // get the recommendations and set move hints
          let seatCount = (trigger === 'screen-touch') ? toBeSelectedIndexes.length : toBeSelectedIndexes.length + 1;
          this.hintEditModeDestination(seatCount);
        }
      },

      /* set the bulk move destination seat and bulk move the seats */
      setBulkMoveDestination(bulkMoveDestination, destinationIndex) {
        if (this.bulkMoveOrigin && this.bulkMoveOrigin.id !== bulkMoveDestination.id) {
          this.bulkMoveDestination = bulkMoveDestination;
          console.log("Mouse Up:", this.bulkMoveDestination.rowLabel, this.bulkMoveDestination.slotNumber);
        } else {
          if (this.bulkMoveOrigin)
            console.log("Cancelled Mouse Down:", this.bulkMoveOrigin.rowLabel, this.bulkMoveOrigin.slotNumber);
          this.bulkMoveOrigin = null;
        }

        if (this.bulkMoveOrigin) {
          let toBeReleasedIndexes = [],
            toBeReservedIndexes = [];

          // get the first seat to be released index
          let originIndex = this.slots.indexOf(this.bulkMoveOrigin);
          toBeReleasedIndexes.push(originIndex);

          // get all left reserved seat indexes in the origin row
          let toBeReleasedSeats = this.getNextReservedRightSlots(this.bulkMoveOrigin);
          for (let i = 0; i < toBeReleasedSeats.length; i++) {
            toBeReleasedIndexes.push(this.slots.indexOf(toBeReleasedSeats[i]));
          }

          // release the group of selected seats
          toBeReleasedIndexes.forEach((toBeReleasedIndex) => {
            let toBeReleasedSeat = this.slots[toBeReleasedIndex];
            toBeReleasedSeat.reserved = false;
            this.slots.splice(toBeReleasedIndex, 1, toBeReleasedSeat);
            this.selectedSlotIndexes.splice(this.selectedSlotIndexes.indexOf(toBeReleasedIndex), 1);
          });

          // get the first seat to be reserved index
          toBeReservedIndexes.push(destinationIndex);

          // get n left available seat indexes in the destination row
          let toBeReservedSeats = this.getNextAvailableRightSlots(this.slots[destinationIndex], toBeReleasedSeats.length);
          for (let i = 0; i < toBeReservedSeats.length; i++) {
            toBeReservedIndexes.push(this.slots.indexOf(toBeReservedSeats[i]));
          }

          // reserve the group of available seats
          toBeReservedIndexes.forEach((toBeReservedIndex) => {
            let toBeReservedSeat = this.slots[toBeReservedIndex];
            toBeReservedSeat.reserved = true;
            this.slots.splice(toBeReservedIndex, 1, toBeReservedSeat);
            this.selectedSlotIndexes.push(toBeReservedIndex);
          });
        }
      },

      getNextAvailableRightSlots(currSeat, count) {
        let row = [];
        let rightSlots = [];
        this.slotsUnbound.forEach((slot) => {
          if (currSeat.rowLabel === slot.rowLabel && slot.status === 'ACTIVE' && !slot.booked && !slot.reserved && slot.x > currSeat.x)
            row.push(slot);
        });
        row.sort(this.sortSeatsByXAsc);
        for (let i = 0; i < count && i < row.length; i++) {
          rightSlots.push(row[i]);
        }

        return rightSlots;
      },

      getNextReservedRightSlots(currSeat) {
        let row = [];
        let prevSlot = currSeat;
        this.slotsUnbound.forEach((slot) => {
          if (currSeat.rowLabel === slot.rowLabel && slot.status === 'ACTIVE' && slot.reserved && slot.x > currSeat.x
            && (slot.x < prevSlot.x + this.defaultSeatWidth + 20)) {
            row.push(slot);
            prevSlot = slot;
          }
        });
        row.sort(this.sortSeatsByXAsc);

        return row;
      },

      /* Sort seats from left to right */
      sortSeatsByXAsc(a, b) {
        return a.x - b.x;
      },

      /* Sort seats from right to left */
      // sortSeatsByXDsc(a, b) {
      //   return b.x - a.x;
      // },

      /* Sort rows from top to bottom */
      sortRowsByYAsc(a, b) {
        return a[0].y - b[0].y;
      },

      /* Sort rows from bottom to top */
      // sortRowsByYDsc(a, b) {
      //   return b[0].y - a[0].y;
      // },

      /* Sort recommended slots by score sum DESC */
      sortRecommendedSlotsByScoreSum(a, b) {
        let sumA = this.getScore(a.slots), sumB = this.getScore(b.slots),
          xA = a.slots[0].x, yA = a.slots[0].y, xB = b.slots[0].x, yB = b.slots[0].y,
          rowA = a.slots[0].rowLabel.toLocaleLowerCase(), rowB = b.slots[0].rowLabel.toLocaleLowerCase();
        if (sumA === sumB) {
          if (rowA === rowB) {
            return xA - xB;
          } else {
            return yA - yB;
          }
        } else
          return sumB - sumA;
      },

      /* map vuex actions */
      ...mapActions([
        'setStandAlonePage', 'setCanvasZoom'
      ]),

      /* get business rules */
      // getBusinessRules() {
      //   axios.post(BACKEND_URL+'/api/business-rules/ids', this.bRuleIDs).then(({data})=>{
      //     this.businessRules = data;
      //
      //     // Call the seat recommendation function
      //     if (!this.foundPreselectedSeats)
      //       this.recommendSeats();
      //     else
      //       this.loading = false;
      //   }).catch((error)=>{
      //     if (error.message === 'Network Error') {
      //       // console.log('Cannot connect to server');
      //       this.backendError = {};
      //       this.backendError.message = 'Cannot connect to server';
      //     } else {
      //       // console.log(error);
      //       this.backendError = error.response.data;
      //     }
      //     this.loading = false;
      //   });
      // },

      /* Get all available seats (exclude inactive(broken), booked, reserved, wheelchair and companion) */
      getAvailableNormalSeats() {
        let availableSeats = [];
        this.slotsUnbound.forEach((slot) => {
          if (slot.status === 'ACTIVE' && !slot.booked && !slot.reserved &&
            [this.SLOT_CATEGORY_WHEELCHAIR, this.SLOT_CATEGORY_COMPANION].indexOf(slot.slotCategory.id) < 0)
            availableSeats.push(slot);
        });
        return availableSeats;
      },

      /* Get a list of recommendations by seat score */
      getRecommendedSeatsByScoring(seats, seatCount) {
        // Group available seats by row label
        let groupedSeatsByRow = this.groupBy(seats, 'rowLabel');

        // Sort row list from top to bottom
        groupedSeatsByRow.sort((a, b) => this.sortRowsByYAsc(a, b));

        // Get lateral segments from each row
        let segments = [], rowSegments = [];
        groupedSeatsByRow.forEach((row) => {
          row.sort((a, b) => this.sortSeatsByXAsc(a, b)); // sort the row asc
          rowSegments = this.getGapLessSegments(row);
          rowSegments.forEach((segment) => {
            segments.push(segment);
          });
        });

        // Get all possible matches based on the number of requested seats
        let possibleMatches = [];
        segments.forEach((slotSegment) => {
          if (slotSegment.length >= seatCount && seatCount > 0) {
            for (let i = 0; i <= (slotSegment.length - seatCount); i++) {
              let possibleMatch = {};
              possibleMatch.offsetLeft = i;
              possibleMatch.offsetRight = slotSegment.length - (i + seatCount);
              possibleMatch.slots = slotSegment.slice(i, (i + seatCount));
              possibleMatches.push(possibleMatch);
            }
          }
        });

        // Sort all possible matches by scoring
        return possibleMatches.sort((a, b) => this.sortRecommendedSlotsByScoreSum(a, b));
      },

      /* Apply NO_ODD_SEATS business rule */
      applyNoOddSeatsRule(recommendationObj, activeBusinessRule) {
        let recommendedSlots = [], fallbackSlots = [];
        recommendationObj.recommended.forEach((recommendation) => {
          if ((recommendation.offsetLeft % 2) === 0 && (recommendation.offsetRight % 2) === 0) {
            // check slot categories
            let passesTheRuleCheck = true;
            for (let i = 0; i < recommendation.slots.length; i++) {
              let slot = recommendation.slots[i];
              if (activeBusinessRule.slotCategories.indexOf(slot.slotCategory.id) < 0) {
                passesTheRuleCheck = false;
                break;
              }
            }
            if (passesTheRuleCheck)
              recommendedSlots.push(recommendation);
            else
              fallbackSlots.push(recommendation);
          }
          else
            fallbackSlots.push(recommendation);
        });
        recommendationObj.recommended = recommendedSlots;
        recommendationObj.fallback = recommendationObj.fallback.concat(fallbackSlots);

        return recommendationObj;
      },

      /* Get recommendations */
      getSeatRecommendations(seatCount) {
        let availableSeats = this.getAvailableNormalSeats();
        let recommendations = this.getRecommendedSeatsByScoring(availableSeats, seatCount);

        /* Apply active recommendation rules */
        let recommendationObj = { recommended: recommendations, fallback: [] };
        let formattedActiveRules = this.setActiveBusinessRules();
        for (let i = 0; i < formattedActiveRules.length && recommendationObj.recommended.length > 0; i++) {
          if (formattedActiveRules[i].type === 'NO_ODD_SEATS') {
            recommendationObj = this.applyNoOddSeatsRule(recommendationObj, formattedActiveRules[i]);
          }
        }
        console.log("recommendations", recommendationObj);
        return recommendationObj;
      },

      /* seat recommendation logic */
      // recommendSeats() {
      //   let recommendationObj = this.getSeatRecommendations(this.intNumSeats);
      //
      //   let recommendedSlots = (recommendationObj.recommended.length > 0) ?
      //     recommendationObj.recommended : recommendationObj.fallback;
      //
      //   // select the first recommended seats
      //   if (recommendedSlots.length > 0) {
      //     recommendedSlots[0].slots.forEach((slot) => {
      //       this.reserveSeat(slot);
      //       this.selectedSlotIndexes.push(this.slots.indexOf(slot));
      //     });
      //     this.loading = false;
      //   } else {
      //     console.log("We couldn't find any seats recommendations at the moment");
      //     this.loading = false;
      //   }
      // },

      /* Select a seat (reserve) */
      // reserveSeat(slot) {
      //   let seatIndex = this.slots.indexOf(slot);
      //   let mySlot = this.slots[seatIndex];
      //   mySlot.reserved = true;
      //   this.slots.splice(seatIndex, 1, mySlot);
      //   this.slotsUnbound.splice(seatIndex, 1, mySlot);
      // },

      /* Group collection(array of objects) By a specific field */
      groupBy(collection, property) {
        let i = 0, val, index,
          values = [], result = [];
        for (; i < collection.length; i++) {
          val = collection[i][property];
          index = values.indexOf(val);
          if (index > -1)
            result[index].push(collection[i]);
          else {
            values.push(val);
            result.push([collection[i]]);
          }
        }
        return result;
      },

      /* Get total score of a list of slots */
      getScore(slots) {
        let totalScore = 0;
        slots.forEach((slot) => {
          totalScore += (slot.slotScore && slot.slotScore > 0) ? slot.slotScore : 0;
        });
        return totalScore;
      },

      /* Calculate the previously available seats */
      // getPreviouslyAvailableSeatsNumber() {
      //   this.previouslyAvailableSeats = this.availableSeat + this.selectedSeatsIds.length;
      // },

      /* return gap-less segments */
      getGapLessSegments(ascSortedRow) {
        let pIndex = 0, segments = [], prevSlot;
        ascSortedRow.forEach((slot, index) => {
          if (index === 0) {
            segments.push([slot]);
            prevSlot = slot;
          } else {
            if (slot.x > (prevSlot.x + ((this.defaultSeatWidth - 4) * 2))) {
              segments.push([slot]);
              prevSlot = slot;
              pIndex++;
            } else {
              segments[pIndex].push(slot);
              prevSlot = slot;
            }
          }
        });
        return segments;
      },

      /* Set Slot.reposition attribute to false on all selected seats(reserved) */
      setRepositionToFalse() {
        this.selectedSlotIndexes.forEach((selectedIndex) => {
          let selectedSlot = this.slotsUnbound[selectedIndex];
          selectedSlot.reposition = false;
          this.slotsUnbound.splice(selectedIndex, 1, selectedSlot);
        });
      },

      /* Set Slot.repositionHint attribute to false on all slots */
      setRepositionHintToFalse() {
        this.slotsUnbound.forEach((slot, index) => {
          slot.repositionHint = false;
          this.slotsUnbound.splice(index, 1, slot);
        });
      },

      /* Set repositionHint attribute on a specified slot to true */
      setRepositionHintToTrue(seat) {
        let seatIndex = this.slotsUnbound.indexOf(seat);
        seat.repositionHint = true;
        this.slotsUnbound.splice(seatIndex, 1, seat);
      },

      hintEditModeDestination(seatCount) {
        this.setRepositionHintToFalse();
        let recommendations = this.getSeatRecommendations(seatCount);
        if (recommendations.recommended.length > 0) {
          recommendations.recommended.forEach((recommendation) => {
            this.setRepositionHintToTrue(recommendation.slots[0]);
          });
        } else if (recommendations.fallback.length > 0) {
          this.setRepositionHintToTrue(recommendations.fallback[0].slots[0]);
        }
      },

      // setUnboundSlots() {
      //   this.slotsUnbound = JSON.parse(JSON.stringify(this.slots));
      //   console.log("Unbound slots assigned");
      // }

      setSelectedSeats() {
        let selectedSeats = [];
        let aSeats = 0;
        let i = 0;
        // for (i; i < this.slots.length; i++) {
        for (i; i < this.slotsUnbound.length; i++) {
          // let seat = this.slots[i];
          let seat = this.slotsUnbound[i];
          if (seat.reserved)
            selectedSeats.push(seat);
          if (!(seat.reserved || seat.booked || seat.status === 'BROKEN'))
            aSeats += seat.capacity;
        }
        this.selectedSeats = selectedSeats;
        this.availableSeat = aSeats;
      },

      setActiveBusinessRules() {
        let activeRules = [], benchmark = 0;
        this.activeBusinessRules.forEach((businessRule) => {
          let slotCategories = [];
          if (businessRule.businessRuleSlotClassifications) {
            businessRule.businessRuleSlotClassifications.forEach((catClassification) => {
              slotCategories.push(catClassification.slotCategory.id);
            });
          }
          benchmark = this.getBenchmarkByChannelCode(businessRule.ruleBenchmarks, this.channel);
          // if (this.bookingPercent < benchmark) {
            let activeRule = {};
            activeRule.type = businessRule.type;
            activeRule.benchmark = benchmark;
            activeRule.slotCategories = slotCategories;
            activeRules.push(activeRule);
          // }
        });
        return activeRules.sort((a, b) => {return b.benchmark - a.benchmark});
      }
    },

    created() {
      /* get the event details */
      this.getEvent();
    }
  }
</script>

<style scoped>
  .c-canvas {
    /*background: #ffffff;*/
    /*background: #f3eee6;*/
    /*border: 1px solid black;*/
    margin-left: auto;
    margin-right: auto;
    position: relative;
  }
  .c-canvas-kiosk {
    /*margin-left: auto;*/
    /*margin-right: auto;*/
    position: relative;
  }
  .booking-page-body-content {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .input-group__details {
    display: none !important;
  }
</style>




// WEBPACK FOOTER //
// src/components/booking/Booking.vue